import {AlertDescription} from '@chakra-ui/react';

export default function ChakraAlertDescription({children, ...rest}) {
    return <AlertDescription {...rest}>{children}</AlertDescription>;
}
